export const setDesktop = desktop => ({
    type: 'SET_DESKTOP',
    payload: desktop
})